export default "__VITE_ASSET__6d42081c__"